import { useMemo } from 'react';
import { useActiveControl } from '../useActiveControl';
import type { useActiveControlProps } from '../useActiveControl';

export type useModalProps = useActiveControlProps & {
  isRequired?: boolean;
  heading?: string;
  size?: 'lg' | 'sm' | 'md';
  backButton?: boolean;
  returnFocusOnDeactivate?: boolean;
};

export const useModal = ({
  isRequired,
  initialActive,
  heading,
  size,
  backButton,
  returnFocusOnDeactivate = false
}: useModalProps) => {
  const modalControl = useActiveControl({ initialActive });
  const { isActive, open, close } = modalControl;
  /**
   * Initiator Props
   */
  const initiatorProps = {
    onClick: open
  };

  /**
   * Modal Props
   */
  const modalProps = useMemo(
    () => ({
      isActive,
      onBlModalClose: close,
      dismissible: !isRequired,
      disableBackdropClick: isRequired,
      disableEscClick: isRequired,
      heading,
      size,
      backButton,
      returnFocusOnDeactivate
    }),
    [
      backButton,
      close,
      heading,
      isActive,
      isRequired,
      returnFocusOnDeactivate,
      size
    ]
  );

  return {
    modalControl,
    modalProps,
    initiatorProps
  };
};
